import ContactForm from "../contact-form/contact-form";
import Socials from "../socials/socials";
import ScrollAnimation from "react-animate-on-scroll";
import contactImage from "../../assets/contact.webp";
import "./contact-page.css";

export default function ContactPage() {
  return (
    <ScrollAnimation animateIn="fadeIn"animateOnce= {true}>
      <div className="ae-contact-page">
        <h1 className="ae-contact-page-title">Get in touch</h1>
        <div className="ae-card -dark-theme -shadow">
          <div className="ae-contact-form-side">
            <img src={contactImage} className="ae-contact-form-logo" alt="" />
            <h2>We are here to help.</h2>
            <p>Fill in the form to let us know how we can help you and get the ball rolling.</p>
            <Socials
              theme={"light"}
              position={"center"} />
          </div>
          <ContactForm />
        </div>
      </div>
    </ScrollAnimation>
  )
}